import React, { memo } from "react";
import { formats } from "investira.sdk";
import { HighchartsReact } from "investira.react.charts";

const DurationChart = memo((props) => {
  const { data = [] } = props;

  const DURATION_LEGENDS = {
    0: "Até 1 ano",
    1: "De 1 a 2 anos",
    2: "De 2 a 3 anos",
    3: "De 3 a 5 anos",
    5: "De 5 a 10 anos",
    10: "Acima de 10 anos",
  };

  const processData = (data) => {
    const xMainData = [];

    Object.entries(data).forEach(([key, item], xIndex) => {
      xMainData.push({
        name: DURATION_LEGENDS[key],
        y: item.percentual,
        dataLabels: {
          color: "#FFFFFF",
        },
        metadata: {
          name: key,
          ...item,
          valor: formats.formatNumber(item.valor, 2, true, true),
        },
      });
    });

    return xMainData;
  };

  const xOptions = {
    chart: {
      type: "pie",
      height: "320px",
    },
    title: false,
    plotOptions: {
      pie: {
        innerSize: "50%",
        borderColor: "#2e2e46",
        borderWidth: 2,
        shadow: false,
        center: ["50%", "50%"],
        dataLabels: {
          enabled: true,
          useHTML: true,
          formatter: function () {
            return `<span style="color: #FFFFFF; text-decoration: none;">${this.point.name}</span>`;
          },
          style: {
            color: "#FFFFFF",
            textOutline: "none",
          },
        },
      },
    },
    tooltip: {
      useHTML: true,
      style: {
        zIndex: 1000,
      },
      pointFormat: `Financeiro: <b>{point.metadata.valor}</b><br>Percentual: <b>{point.metadata.percentual}%</b>`,
    },
    series: [
      {
        name: "Duration",
        colorByPoint: true,
        data: processData(data),
        dataLabels: {
          color: "#ffffff",
          enabled: true,
          style: {
            fontSize: "11px", // Reduz o tamanho da fonte
          },
        },
      },
    ],
  };

  return <HighchartsReact options={xOptions} drilldown />;
});

export default DurationChart;
